// extracted by mini-css-extract-plugin
export default {"videoContainer":"styles_videoContainer__rnQiS","video":"styles_video__AJWAM"};